import React from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { Catcher, LinkComponent, LoadingApiByIds, ShowDataBytes, TableItemToolbar, columnToolbar } from '../../';
import { ShowDataProgress } from '../../SmallComponents/ShowDataProgress';
import { IPackageSoldInfo, IPackagesTable } from '../../../interfaces';
import { usePackagesSold, usePagesStoreThisListRight, useProfileIsRight } from '../../../hooks';
import { deletePackageInstance } from '../../../middleware';
import { tF, tI } from '../../../translate';
import { PackageCountDown } from '../../Package/Components';
import Styles from '../../styles/m_viewStyles.less';
import ViewStyles from '../../styles/m_viewStyles.less';

export const TableForBought: React.FC<IPackagesTable> = observer(({ pageSize, pageNumber, search }: IPackagesTable) => {
    const right = usePagesStoreThisListRight();
    const data = usePackagesSold();
    const isLord = useProfileIsRight('LORD');

    const tableColumns = [
        {
            title: tF('Package Owner'),
            dataIndex: 'companyLink',
        },
        {
            title: tF('Package Name'),
            dataIndex: 'packageLink',
        },
        {
            title: tF('Data left'),
            dataIndex: 'showSoldVolume',
            className: ViewStyles.columnRight,
        },
        {
            title: tF('Package Size'),
            dataIndex: 'showPackageVolume',
            className: ViewStyles.columnRight,
        },
        {
            title: tF('Expires in'),
            dataIndex: 'isExpiredName',
        },
        {
            title: tF('Zone'),
            dataIndex: 'zoneLink',
        },
        {
            title: tF('Assigned Cardset'),
            dataIndex: 'cardSetLink',
        },
        {
            title: tF('Credit Remains'),
            dataIndex: 'creditRemainsName',
        },
        {
            title: tF('Auto renewal'),
            dataIndex: 'renewalName',
        },
        columnToolbar,
    ];

    const tableData = data?.map(
        ({
            isExpired,
            creditRemains,
            dataVolumeByte,
            soldVolumeByte,
            expiresDate,
            createdAt,
            renewal,
            ...p
        }: IPackageSoldInfo) => {
            const isAvailableForDelete = isExpired && (!creditRemains || (!!dataVolumeByte && dataVolumeByte <= 0)); //:TODO move to the package body
            const params = {
                searchParamsList: {
                    pageNumber,
                    pageSize,
                    search,
                },
            };

            const deleteItem = (): void => {
                deletePackageInstance(p.id, params);
            };
            const showPackageName = p.packageName ? p.packageName : `# ${p.id}`;

            return {
                key: p.id,
                ...p,
                companyLink: (
                    <LinkComponent currentListComponent={'CompaniesList'} id={p.companyId} name={p.companyName} />
                ),
                packageLink: <LinkComponent currentListComponent={'PackagesBuy'} id={p.id} name={p.packageName} />,
                zoneLink: <LinkComponent currentListComponent={'ZonesList'} id={p.zoneId} name={p.zoneName} />,
                cardSetLink: (
                    <LinkComponent currentListComponent={'CardSetsList'} id={p.cardSetId} name={p.cardSetName} />
                ),
                showSoldVolume: (
                    <div className={Styles.columnContentCol100}>
                        <ShowDataBytes bytes={soldVolumeByte} isHumanView noDataText={'No data'} />
                        <ShowDataProgress limit={dataVolumeByte} used={soldVolumeByte} />
                    </div>
                ),
                showPackageVolume: (
                    <div className={Styles.columnContentCol100}>
                        <ShowDataBytes bytes={dataVolumeByte} isHumanView noDataText={'Unlimited'} />
                    </div>
                ),
                isExpiredName: (
                    <div className={Styles.columnContentCol100}>
                        <PackageCountDown
                            expiresDate={expiresDate}
                            createdAt={createdAt}
                            isExpired={isExpired}
                            isRenewed={renewal}
                        />
                    </div>
                ),
                toolbar: (
                    <TableItemToolbar
                        itemName={`"${showPackageName}" ${tI('package')}`}
                        id={p.id}
                        {...right}
                        currentListComponent={'PackagesBuy'}
                        deleteItem={deleteItem}
                        isDelete={isAvailableForDelete || isLord}
                        isEdit={!isAvailableForDelete}
                    />
                ),
            };
        },
    );

    return (
        <Catcher>
            <div>
                <LoadingApiByIds idSpinners={['GET_BOUGHT_PACKAGES']} />
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
